module.exports = __webpack_public_path__ + "img/ic-download.a49bad86.svg";